import React from 'react';

import QuizSubjectPage from '../../subjects/QuizSubjectPage';

function Quiz() {

 

  return (

    <>
      
      <QuizSubjectPage 
        name="NEET Mock Test Series 2025 (Full, Subject & Topic Wise)" 
        link="quiz" 
        type="quiz" 
        subject="atoz" 
        topic="atoz" 
        subjectName="All subjects" 
      />

     
    </>
  );
}

export default Quiz;